import React, { useState } from 'react';
import useAsyncEffect from 'use-async-effect';
import styled from 'styled-components'
import { useDispatch, useSelector } from 'react-redux';
import SortableTable from '../table/SortableTable';
import { loading } from '../../actions/Loading';
import api from '../../api/api';
import { ClientDashboardResult } from '../../model/ClientDashboardResult';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { IGlobalState } from '../../model/IGlobalState';
import { HasStockRole } from '../../model/Roles';
import * as Roles from '../../model/Roles';
import { history } from '../../index';

const Style = styled.div`

`


const ClientDashboard: React.FC= () => {
    const dispatch = useDispatch();
    const [ item, setItem ] = useState<ClientDashboardResult>();
    
    const user = useSelector((state: IGlobalState) => state.user)
    
    
    
    
    
    useAsyncEffect(async (isMounted:()=>boolean)=> {
        dispatch(loading(true));
        const result = await api().getClientDashboardResult();
        
        if(result.stocks.length === 1){
            history.push(`/client-stocks/${result.stocks[0].combinedTicker}`);
            return;
        }
        
        if(isMounted()){

            setItem(result)
        }
        dispatch(loading(false));
        
      }, []);

      const cellFormatter = (columnName:string, cell:any, stock:any):React.ReactNode => {
        if(columnName==='Ticker'){
            const newTo = {
                pathname: `/client-stocks/${stock.combinedTicker}`,
                id: stock.id
              };
            return <Link to={newTo}  >{cell}</Link>
        }
        else if(columnName ==='Website'){
            return <a target="_blank"
            href={cell}
            rel="noopener noreferrer"
        >     <span>{cell}</span>
        </a>
        }
        else if(columnName ==='Confirmation Email'){
            const email = cell as string;
            if(email != null){
                const addresses = email.split(/[,;]+/)
                return <div>
                    { addresses.map((x,i)=> <div key={i}>{x}</div>)}
                </div>
            }
        }
        else if(columnName ==='Invoice'){
            if(stock != null && stock.invoiceTotal){
                const url = api().getUrl(`/api/invoice?ticker=${stock.combinedTicker}&invoiceId=${stock.invoiceId}`);

                const unpaid = stock.invoiceStatus !== "PAID";
                let daysLate:number|undefined;
                let overdueClass = "";
                if(unpaid){
                    const duration = moment.duration(moment().diff(moment(stock.invoiceDate)));
                    daysLate = Math.floor(duration.asDays());
                    if(daysLate > 90){
                        overdueClass = "overdue";
                    }
                }

                return <>
                <a target="_blank"
                href={url}
                rel="noopener noreferrer">     <span>{stock.invoiceNumber}</span>
                    </a>
                <span> - ${stock.invoiceTotal.toLocaleString()} -
                <span>{moment(stock.invoiceDate).format('DDMMMYY')} - </span>
                {unpaid ? "Unpaid - " : "Paid"}
                { daysLate && <> <span className={overdueClass}>{daysLate} days overdue</span> </>}
                </span>
                </>

            }
        }
        return null;
    }
    const hasInvoicingRole = HasStockRole(user, Roles.Invoicing);
    const hasConfigRole = HasStockRole(user, Roles.Invoicing);    
    const data:any[][] = [];
    if(item){
        for(let stock of item.stocks){
            let arr:any[] = []

            arr = [
                stock.combinedTicker,
            ];
            if(hasConfigRole){
                arr.push(stock.created)
                arr.push(stock.apiKey || '')
                arr.push(stock.websiteUrl || '')
                arr.push(stock.mailchimp ? '✓' : '✕')
                arr.push(stock.confirmationEmail)
            }

            if(hasInvoicingRole){
                arr.push(stock.invoiceId)
            }

            arr.push(stock)

            data.push(arr)
        }
    }
    
    const headers = [ 'Ticker' ]
    if(hasConfigRole){
        headers.push('Created', 'API Key', 'Website', 'Mailchimp','Confirmation Email')
    }

    if(hasInvoicingRole){
        headers.push('Invoice')
    }    

    return <div>
        
        <Style>
        <p className='info'>Select a service by clicking on their Ticker below
        </p>
        <SortableTable headers={headers} data={data} cellFormatter={cellFormatter}  />
    </Style>
        {/* { entries.map(x=> <ClientStockItem key={x[0]} stockId={x[0]} expanded={entries.length===1}/>)} */}

    </div>
}

export default ClientDashboard